import { Injectable } from '@angular/core';
import {decrypt, encrypt} from "../../../../../common/general-functions";

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';

@Injectable({
    providedIn: 'root'
})

export class TokenStorageService {

    constructor() {}

    signOut(): void {
        window.localStorage.clear();
    }

    public saveToken(token: string): void {
      if (typeof window !== 'undefined') {
        window.localStorage.removeItem(TOKEN_KEY);
        window.localStorage.setItem(TOKEN_KEY, encrypt(token));
      }

    }

    public getToken(): string | null {
      if (typeof window !== 'undefined') {
        var token = window.localStorage.getItem(TOKEN_KEY);
        // console.log(token);
        return token ? decrypt(token) : null;
      }
       return null;
    }

    public saveUser(user: any): void {
      if (typeof window !== 'undefined') {
        window.localStorage.removeItem(USER_KEY);
        window.localStorage.setItem(USER_KEY, encrypt(JSON.stringify(user)));
      }
    }

    public getUser(): any {
      if (typeof window !== 'undefined') {
        const user = window.localStorage.getItem(USER_KEY);
        // console.log(user);
        if (user) {
            return JSON.parse(decrypt(user));
        }
        return false;
      }
      return false;
    }

    public removeData(): void{
      if (typeof window !== 'undefined') {
        window.localStorage.removeItem(TOKEN_KEY);
        window.localStorage.removeItem(USER_KEY);
      }
    }
}
